import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Visualization {
  visualization: "TABLE" | "CARD";
}

const initialState: Visualization = {
  visualization: sessionStorage.getItem("visualization")
    ? (sessionStorage.getItem("visualization") as "TABLE" | "CARD")
    : "TABLE",
};

const visualizationSlice = createSlice({
  name: "visualization",
  initialState,
  reducers: {
    changeVisualization(
      state: Visualization,
      action: PayloadAction<"TABLE" | "CARD">
    ) {
      sessionStorage.setItem("visualization", action.payload);
      state.visualization = action.payload;
    },
  },
});

export const visualizationActions = visualizationSlice.actions;

export default visualizationSlice;
